"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSummaryResults = exports.questions = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var questions = [{
  prompt: "These are common triggers so don’t worry if they all feel like trigger for you. Just pick the ones that come up a lot.",
  type: "multiRadio",
  meta: {
    summaryTitle: "My stress triggers are:"
  },
  options: ["Feeling like I don’t have enough money", "Being accused of doing something wrong", "When someone makes me feel like there is something wrong with me", "When people don’t do what they said they would do", "When someone doesn’t give me recognition or love"],
  batteryId: "STRESS_TRIGGERS"
}, {
  prompt: "Or any of these?",
  type: "multiRadio",
  meta: {
    summaryTitle: "My stress triggers are:"
  },
  options: ["When it feels like I’m failing at something", "When someone gossips or says bad things about me behind my back", "Feeling like my freedom or choices are being restricted by someone else", "Feeling stupid or dumb", "When someone acts in a controlling or manipulative way", "When someone acts unfairly towards me or others"],
  batteryId: "STRESS_TRIGGERS"
}, {
  prompt: "Now that you know what triggers are, it can really help to write down any personal triggers for you that we didn’t cover.",
  type: "textarea",
  meta: {
    answerLabel: "Personal triggers...",
    summaryTitle: "My stress triggers are:"
  },
  batteryId: "STRESS_TRIGGERS"
}, {
  prompt: "Ok, so you know your triggers a bit better. What can you do to support yourself when you are triggered?",
  type: "multiRadio",
  meta: {
    summaryTitle: "Activities to support myself when you I am triggered:"
  },
  options: ["Retraining thinking exercises", "Taking actions based on values", "Breathing exercises", "Reading, listening to or watching something uplifting or inspirational", "Using sticky notes or post-it notes with beliefs to remember"],
  batteryId: "STRESS_TRIGGERS"
}, {
  prompt: "any of these?",
  type: "multiRadio",
  meta: {
    summaryTitle: "Activities to support myself when you I am triggered:"
  },
  options: ["Attending a group or a meeting of people that support your growth", "Yoga or meditation practice", "Reading, listening to or watching self-help", "Housework or homework", "Prayer or spiritual practices", "Exercise"],
  batteryId: "STRESS_TRIGGERS"
}, {
  prompt: "any of these?",
  type: "multiRadio",
  meta: {
    summaryTitle: "Activities to support myself when you I am triggered:"
  },
  options: ["Meeting or calling someone who supports your growth", "Journalling", "Gratitude", "Random Act of Kindness", "Go for a walk", "Sit in the car and do some yelling by myself"],
  batteryId: "STRESS_TRIGGERS"
}, {
  prompt: "lastly any of these?",
  type: "multiRadio",
  meta: {
    summaryTitle: "Activities to support myself when you I am triggered:"
  },
  options: ["Hit a punching bag or bash a pillow", "Picture myself at 90 and ask for some advice from my older self", "Imagine what a good friend would say and the advice they’d give"],
  batteryId: "STRESS_TRIGGERS"
}, {
  prompt: "Anything that I missed that you personally find useful?",
  type: "textarea",
  meta: {
    answerLabel: "Personal activities for support..",
    summaryTitle: "Activities to support myself when you I am triggered:"
  },
  batteryId: "STRESS_TRIGGERS"
}];
exports.questions = questions;

var getSummaryResults = function getSummaryResults(answers) {
  return questions.map(function (question, index) {
    if (!question.hideFromSummary && answers[question.batteryId][index]) {
      if (question.type === "radio") {
        return {
          question: question,
          answer: question.options[answers[question.batteryId][index]]
        };
      } else {
        return {
          question: question,
          answer: answers[question.batteryId][index]
        };
      }
    }
  }).filter(function (item) {
    return _typeof(item) === "object";
  });
};

exports.getSummaryResults = getSummaryResults;